import { Injectable, computed, inject } from '@angular/core'

import { memoize } from 'lodash'

import { WorkspacesAndPermissionsStore } from '@flowx/designer/modules/workspaces/workspaces-and-permissions.store'

export enum DOCS_SLUG {
  TASK_MANAGER_OVERVIEW = 'task-manager-overview',
  DATA_SEARCH = 'data-search',
  EXPIRY_TIME = 'expiry-time',
  SENSITIVE_DATA = 'sensitive-data',
  TIMER_EVENTS = 'timer-events',
  BUSINESS_RULE_ACTION = 'business-rule-action',
  UPDATE_PROCESS_VARIABLES = 'update-process-variables',
}

@Injectable({
  providedIn: 'root',
})
export class DocsService {
  readonly #workspacesAndPermissionsStore = inject(WorkspacesAndPermissionsStore)
  readonly #platformVersion = this.#workspacesAndPermissionsStore.platformVersion

  readonly #majorMinor = computed(() => {
    const platformVersion = this.#platformVersion()
    const versionParts = platformVersion.split('.')
    if (versionParts.length < 2) {
      console.warn(`Invalid platform version format. Current version from api: ${platformVersion}`)
      return null
    }
    const [major, minor] = versionParts.slice(0, 2)

    return `${major}.${minor}`
  })

  private docsBaseUrl = 'https://docs.flowx.ai'

  getDocsLink = memoize((slug: DOCS_SLUG): string =>
    this.#majorMinor()
      ? `${this.docsBaseUrl}/link/${this.#majorMinor()}/${slug} `
      : `${this.docsBaseUrl}`
  )
}
